<template>
  <div style="display: inline-block;">
    <b-dropdown right variant="itg">
      <template v-slot:button-content>
        Sort By{{ sortByOption ? ': ' + sortByOption.label : '' }}
        <i class="mdi mdi-chevron-down"></i>
      </template>
      <b-dropdown-item @click.prevent="setSortBy(option)"
                       v-for="(option, i) in sortByOptions" :key="i">{{ option.label }}
      </b-dropdown-item>
    </b-dropdown>

    <b-dropdown right variant="itg" class="ml-2">
      <template v-slot:button-content>
        {{ sortOrderOption ? sortOrderOption.label : '' }}
        <i class="mdi mdi-chevron-down"></i>
      </template>
      <b-dropdown-item @click.prevent="setSortOrder(option)"
                       v-for="(option, i) in sortOrderOptions" :key="i">{{ option.label }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
const _ = require('lodash');
export default {
  name: "SortByFilters",
  props: ['filters'],
  data() {
    return {
      sortByOptions: [
        {
          label: 'Difficulty',
          value: 'difficulty'
        },
        {
          label: 'Priority',
          value: 'priority'
        },
        {
          label: 'Created At',
          value: 'created_at'
        },
        {
          label: 'Received At',
          value: 'received_at'
        },
        {
          label: 'Resolved At',
          value: 'resolved_at'
        },
        {
          label: 'Closed At',
          value: 'closed_at'
        },
        {
          label: 'Subject',
          value: 'subject'
        },
        {
          label: 'Source',
          value: 'source'
        },
        {
          label: 'Last Communication From ITG',
          value: 'last_communication_from_itg'
        },
        {
          label: 'Last Communication From Client',
          value: 'last_communication_from_client'
        }
      ],
      sortOrderOptions: [
        {
          label: 'Descending',
          value: 'DESC'
        },
        {
          label: 'Ascending',
          value: 'ASC'
        }
      ]
    }
  },
  computed: {
    sortByOption() {
      return _.find(this.sortByOptions, {
        value: this.filters.sort_by
      });
    },

    sortOrderOption() {
      return _.find(this.sortOrderOptions, {
        value: this.filters.sort_order
      });
    }
  },
  methods: {
    setSortBy(option) {
      this.filters.sort_by = option.value;
    },

    setSortOrder(option) {
      this.filters.sort_order = option.value;
    }
  }
}
</script>

<style scoped>

</style> 